export const POST_CUSTOMER_LEADS_UNSUBSCRIBE = 'CUSTOMERS/LEADS/POST_UNSUBSCRIBE_REQUEST';
export const POST_CUSTOMER_LEADS_UNSUBSCRIBE_SUCCESS = 'CUSTOMERS/LEADS/POST_UNSUBSCRIBE_SUCCESS';
export const POST_CUSTOMER_LEADS_UNSUBSCRIBE_FAILURE = 'CUSTOMERS/LEADS/POST_UNSUBSCRIBE_FAILURE';
